// Global Dawn Theme JS

(function() {
  'use strict';

  // Cart count update
  if (typeof window.cartStrings !== 'undefined') {
    // Cart functionality can be added here
  }

  // Variant selection
  if (typeof window.variantStrings !== 'undefined') {
    // Variant functionality can be added here
  }
})();




